import {createSlice} from '@reduxjs/toolkit';

const initialAgentsIncomesState = {
  listLoading: false,
  totalAgentsCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};
export const callTypes = {
  list: 'list',
  action: 'action'
};

export const agentsIncomesSlice = createSlice({
  name: 'agentsIncomes',
  initialState: initialAgentsIncomesState,
  reducers: {
    agentsIncomesFetched: (state, action) => {
      const {totalAgentsCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalAgentsCount = totalAgentsCount;
      state.pageCount = pageCount;
    },
    agentsIncomesAppended: (state, action) => {
      const {totalAgentsCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalAgentsCount = totalAgentsCount;
      state.pageCount = pageCount;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoicesError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
